import { render } from "./XIconSolidLandmark.vue?vue&type=template&id=548cf0c0"
import script from "./XIconSolidLandmark.vue?vue&type=script&lang=js"
export * from "./XIconSolidLandmark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLandmark.vue"]])

export default __exports__